'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _v = require('uuid/v1');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global googletag */
var getAdId = function getAdId(adUnit, uuid) {
  return adUnit + '-' + uuid;
};

var GoogleDFP = function (_Component) {
  (0, _inherits3.default)(GoogleDFP, _Component);

  function GoogleDFP() {
    (0, _classCallCheck3.default)(this, GoogleDFP);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleDFP.__proto__ || (0, _getPrototypeOf2.default)(GoogleDFP)).call(this));

    _this.initializeAd =
    /* istanbul ignore next */
    function (prevAdConfig) {
      var uuid = _this.state.uuid;
      var _this$props = _this.props,
          adConfig = _this$props.adConfig,
          hide = _this$props.hide,
          companion = _this$props.companion,
          enableSingleRequest = _this$props.enableSingleRequest,
          eventListeners = _this$props.eventListeners;


      var adId = getAdId(adConfig.adUnit, uuid);

      googletag.cmd.push(function () {
        if (prevAdConfig) googletag.destroySlots([_this.adSlot]);

        googletag.pubads().enableAsyncRendering();
        if (enableSingleRequest) googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();

        eventListeners.forEach(function (_ref) {
          var type = _ref.type,
              listener = _ref.listener;

          googletag.pubads().addEventListener(type, listener);
        });

        var mapping = void 0;
        if (!adConfig.adSizeMappings) {
          mapping = googletag.sizeMapping().addSize([1024, 768], adConfig.adSizeDesktop).addSize([980, 690], adConfig.adSizeDesktop).addSize([770, 480], adConfig.adSizeDesktop).addSize([0, 0], adConfig.adSizeMobile).build();
        } else {
          mapping = adConfig.adSizeMappings;
        }

        _this.adSlot = googletag.defineSlot(adConfig.adUnit, adConfig.adSizes, adId).defineSizeMapping(mapping).addService(googletag.pubads()).setTargeting('viewType', adConfig.adViewType);

        if (companion) {
          _this.adSlot.addService(googletag.companionAds());
          _this.adSlot.addService(googletag.pubads());
          googletag.companionAds().setRefreshUnfilledSlots(true);
          googletag.pubads().enableVideoAds();
        }

        adConfig.adTargets.forEach(function (targetData) {
          _this.adSlot.setTargeting(targetData[0], targetData[1]);
        });

        googletag.enableServices();

        if (prevAdConfig) googletag.pubads().refresh([_this.adSlot]);
        if (!hide) googletag.display(adId);
      });
    };

    _this.state = {
      uuid: null
    };
    return _this;
  }

  (0, _createClass3.default)(GoogleDFP, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ uuid: (0, _v2.default)() });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var uuid = this.state.uuid;
      var adConfig = this.props.adConfig;

      if (prevState.uuid !== uuid || !(0, _lodash.isEqual)(prevProps.adConfig, adConfig)) {
        this.initializeAd(prevProps.adConfig);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      googletag.cmd.push(function () {
        googletag.destroySlots([_this2.adSlot]);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var uuid = this.state.uuid;
      var adConfig = this.props.adConfig;


      return _react2.default.createElement(
        'div',
        { className: 'sl-google-dfp', ref: function ref(el) {
            return _this3.ref = el;
          } },
        uuid ? _react2.default.createElement('div', { id: getAdId(adConfig.adUnit, uuid), className: adConfig.adClass }) : null
      );
    }
  }]);
  return GoogleDFP;
}(_react.Component);

GoogleDFP.propTypes = {
  adConfig: _propTypes2.default.shape({
    adUnit: _propTypes2.default.string.isRequired,
    adSizes: _propTypes2.default.array.isRequired,
    adSizeDesktop: _propTypes2.default.array,
    adSizeMobile: _propTypes2.default.array,
    adSizeMappings: _propTypes2.default.array,
    adViewType: _propTypes2.default.string.isRequired,
    adTargets: _propTypes2.default.array.isRequired
  }).isRequired,
  hide: _propTypes2.default.bool,
  companion: _propTypes2.default.bool,
  enableSingleRequest: _propTypes2.default.bool,
  eventListeners: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    type: _propTypes2.default.string.isRequired,
    listener: _propTypes2.default.func.isRequired
  }))
};

GoogleDFP.defaultProps = {
  hide: false,
  companion: false,
  enableSingleRequest: true,
  eventListeners: []
};

exports.default = GoogleDFP;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/GoogleDFP/GoogleDFP.js
// module id = 289
// module chunks = 0